<template>
  <input
    aria-label="Keyword search"
    type="search"
    v-model="query"
    class="form-control"
    :disabled="disabled"
    :placeholder="placeholderText"
    @input="$emit('updatedQuery', query)"
    :ref="refName"
  >
</template>

<script>
import { connectSearchBox } from 'instantsearch.js/es/connectors';
import { createWidgetMixin } from 'vue-instantsearch';
import eventHub from '@/util/event_hub'

function resetTimer(timer) {
  if (timer) {
    clearTimeout(timer);
  }
}

export default {
  mixins: [createWidgetMixin({ connector: connectSearchBox })],
  props: {
    delay: {
      type: Number,
      default: 500,
      required: false,
    },
    placeholderText: {
      type: String,
      default: 'Keyword Search'
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    refName: {
      type: String,
      required: false,
      default: 'keywordInput'
    }
  },
  data() {
    return {
      timerId: null,
      localQuery: '',
    };
  },
  destroyed() {
    resetTimer(this.timerId)
  },
  computed: {
    query: {
      get() {
        return this.localQuery;
      },
      set(val) {
        this.localQuery = val;
        resetTimer(this.timerId)
        this.timerId = setTimeout(() => {
          this.state.refine(this.localQuery);
        }, this.delay);
      },
    },
  },
  created: function() {
    eventHub.$on('clear-keyword', this.clearKeyword)
  },
  beforeDestroy: function() {
    eventHub.$off('clear-keyword', this.clearKeyword)
  },
  methods: {
    clearKeyword: function(refName) {
      this.$refs[refName].value = null;
    }
  }
};
</script>
<style>
</style>